export const payrollKeys = {
  all: ['payroll'] as const,
  runs: () => [...payrollKeys.all, 'runs'] as const,
  run: (id: string) => [...payrollKeys.runs(), id] as const,
  employees: (startDate: string, endDate: string, timezone: string, includeNonWorking: boolean) =>
    [...payrollKeys.all, 'employees', startDate, endDate, timezone, includeNonWorking] as const,
} as const;
